import React from "react";
import classNames from "classnames";

import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Props, Item } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function SelectList<ItemType extends Item>(props: Props<ItemType>) {
  return (
    <VisibilityWatcher>
      {(isOpen, show, hide) => (
        <div
          className={classNames(styles.selectList, {
            [styles.opened]: isOpen,
            [styles.invalidInput]: props.isInvalid,
          })}
        >
          <div className={styles.input} onClick={isOpen ? hide : show}>
            <p>
              {props.selectedItem ? props.selectedItem.name : props.placeholder}
            </p>
            <div className={styles.iconBox}>
              <ArrowIcon className={styles.icon} />
            </div>
          </div>
          {isOpen && (
            <ul className={styles.list}>
              {props.items.map((item) => (
                <li
                  key={item.uuid}
                  className={classNames(styles.item, {
                    [styles.selectedItem]:
                      props.selectedItem &&
                      item.uuid === props.selectedItem.uuid,
                  })}
                  onClick={() => {
                    props.select(item);
                    hide();
                  }}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { SelectList };
